module.exports = __webpack_public_path__ + "img/appleypay.af7387b9.svg";